module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 6-2399ef3d7b88070982fe39b3a699ea8e.jpg";